import React, { Component } from 'react';
import NotificationSystem from 'react-notification-system';

import Api from '../../Services/Api';
import CurrentFBO from '../../Services/CurrentFBO';

import auth from './Auth';

export default class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      message: '',
    };

    this.postForm = this.postForm.bind(this);
    this.handleSubmitOnEnter = this.handleSubmitOnEnter.bind(this);
  }

  postForm() {
    this.request = Api.get('forgotpassword', {
      method: 'POST',
      body: JSON.stringify({
        email: this.state.email,
      }),
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }
    }, false, false).then((response) => {
      this.refs.notificationSystem.addNotification({
        message: response.message,
        level: 'success',
        position: 'tc'
      });
      setTimeout(() => {
        this.props.history.push('/login');
      }, 2500);
    }).catch((error) => {
      console.error(error);
    });
  }

  handleSubmitOnEnter(event) {
    if (event.keyCode === 13) {
      this.postForm();
    }
  }

  render() {
    return (
      <div>
        <NotificationSystem ref="notificationSystem" />
        <div className="authentication-form">
          <h1 className="logo">Huvercraft</h1>
          <div className="form-content">
            <h4>Forgot Password</h4>
            <p>Enter the email address you used to sign up and we'll send you a link to reset your password.</p>
            <input
              id="email"
              type="email"
              placeholder="Email"
              className="first-child last-child"
              value={this.state.email}
              onChange={e => this.setState({ email: e.target.value })}
              onKeyDown={this.handleSubmitOnEnter}
              autoFocus
            />
            <button
              type="button"
              onClick={this.postForm}
              className="btn btn-medium btn-primary"
            >
              Continue
            </button>
          </div>
          <div className="additional-auth-links">
            <a href="/signup">Don't have an account? Signup</a>
          </div>
        </div>
        <div className="spinner hide">
          <div className="bounce1" />
          <div className="bounce2" />
          <div className="bounce3" />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Authentication/ForgotPassword.js